"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCalendarInstance = getCalendarInstance;
const calendar_api_1 = require("./calendar.api");
function getCalendarInstance(calEvent) {
    console.log(' [.ics file downloaded!]');
    return (0, calendar_api_1.ics)(calEvent);
}
